import React from 'react'
import PropTypes from 'prop-types'
import {footerTotals,footerSection} from './footer.css'

const Footer = ({quantity,cost,retail,mu}) => {
    const mbkscost = isNaN(cost) ? 0:cost.toFixed(2);
    const mbksretail = isNaN(retail) ? 0:retail.toFixed(2);
    const mbksmu = isNaN(mu) ? 0:mu.toFixed(2);
    return (
        <div className={footerSection}>
            <span className={footerTotals}>
                <strong>
                    Total Unit QTY: {quantity}
                </strong>
            </span>
            <span className={footerTotals}>
                <strong>
                    Total Ext Cost: {mbkscost}
                </strong>
            </span>
            <span className={footerTotals}>
                <strong>
                    Total Ext Retail: {mbksretail}
                </strong>
            </span>
            <span className={footerTotals}>
                <strong>
                    Total MU%: {mbksmu}
                </strong>
            </span>
        </div>
    )
}

Footer.propTypes = {
    quantity: PropTypes.number.isRequired,
}

export default Footer


// WEBPACK FOOTER //
// ./components/product-detail/Footer.js